export const getPolicyRuleLabel = rule => `#${rule.internal_id} - ${rule.name}`

export const getPolicyRulesMenuItems = policyRules => {
  return policyRules.map(rule => ({ label: getPolicyRuleLabel(rule), value: rule.id }))
}
